import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const selectivedriveConfig: TSPConfig = {
  key: 'selectivedrive',
  name: 'Selective Drive Fleet',
  category: TSPCategory.CUSTOM,
  helpText:
    'Please request an API UUID and password from Selective Drive support. Then input them here.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'UUID', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default selectivedriveConfig;
